<div class="row">
  <app-card [hidHeader]="false" cardTitle="Empresa Cadastrada" [options]="false" class="col-sm-12" id="inicioPagina">
    <div class="row ">
      <div class="col-sm-6 col-xl-6 ">
        <label class="sub-title">Nome</label>
        <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
      </div>
      <div class="col-sm-12 col-xl-3 ">
        <label class="sub-title">CNPJ</label>
        <input type="text" class="form-control" [textMask]="{mask: maskCNPJ}" [(ngModel)]="cnpj" name="cnpj"
          placeholder="">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Telefone </label>
        <input type="text" class="form-control" [textMask]="{mask: maskTelefoneCelular}" [(ngModel)]="telContato"
          name="telContato" placeholder="">
      </div>
    </div>   
  
    <div class="row">
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Email</label>
        <input type="text" class="form-control" [(ngModel)]="appFacebook" name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-6 col-xl-9">
        <label class="sub-title">Website</label>
        <input type="text" class="form-control" [(ngModel)]="token" name="token" placeholder="">
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Responsável Legal</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-6 col-xl-9">
        <label class="sub-title">Setor de Atuação</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>
    <br>  <br>
    <legend>Informações Operacionais</legend>

    <div class="row">
      <div class="col-sm-4 col-xl-4">
        <label class="sub-title">Número de Funcionários</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-4">
        <label class="sub-title">Capacidade Operacional</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-4">
        <label class="sub-title">Número de Filiais</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Serviços Oferecidos</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Certificações Existentes</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-3">
        <label class="sub-title">Data de Fundação</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>

    <br>  <br>
    <legend>Informações Operacionais</legend>


    <div class="row">
      <div class="col-sm-4 col-xl-3">
        <label class="sub-title">Responsável pela Qualidade</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-9">
        <label class="sub-title">Documentos de Qualidade</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Auditorias Anteriores</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Programas de Melhoria Contínua</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Política de Segurança do Paciente</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-4 col-xl-12">
        <label class="sub-title">Comitê de Ética</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>

    <br>  <br>
    <legend>Dados Financeiros e Administrativos</legend>
    
    <div class="row">
      <div class="col-sm-3 col-xl-3">
        <label class="sub-title">Faturamento Anual</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-3 col-xl-3">
        <label class="sub-title">Investimentos em Saúde</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-3 col-xl-3">
        <label class="sub-title">Recursos Humanos</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
      <div class="col-sm-3 col-xl-3">
        <label class="sub-title">Convênios Atendidos</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>

    <br>  <br>
    <div class="row">
      <div class="col-sm-12 ">
        <button type="button" class="btn btn-warning float-left " (click)="voltar()">
          <i class="feather icon-arrow-left mr-2 f-18"></i>
          Voltar
        </button>
        <button type="button" class="btn btn-primary float-right " (click)="salvar()">
          <i class="feather icon-check-circle mr-2 f-18"></i>
          Salvar
        </button>
      </div>
    </div>
  </app-card>
</div>
